import { Fieldset } from 'primereact/fieldset'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomCheckbox, CustomDropdown, InputTime } from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'

function EnvioHorarioSaida({ onBtnSalvarInfo, selectedTp, dispatch, motivosAtraso }) {
  const [horarioSaida, setHorarioSaida] = useState(null)
  const [isLated, setIsLated] = useState(false)
  const [motivoAtraso, setMotivoAtraso] = useState(null)

  const onBtnSalvarClick = () => {
    if (!horarioSaida || horarioSaida.length === 0)
      dispatch(showMessageBox(null, 'Um horario de saida precisa ser definido'))
    else if (isLated && !motivoAtraso)
      dispatch(showMessageBox(null, 'Se o veiculo está atrasado, é necesario indicar um motivo'))
    else {
      onBtnSalvarInfo({
        departure_time: `${horarioSaida.getHours()}:${horarioSaida.getMinutes()}`,
        vehicle_lated: isLated,
        motivo_atraso_id: isLated ? motivoAtraso.id : null,
      })
    }
  }

  return (
    <div>
      <Fieldset legend="Informações Horário de Saida">
        <div className="p-grid p-col-align-center">
          <div className="p-col-2">
            <InputTime
              marginTop={0}
              label="Horário de Saida"
              value={horarioSaida}
              onChange={value => setHorarioSaida(value)}
              newVersion={true}
            />
          </div>
          <div className="p-col-fixed" style={{ marginTop: 25 }}>
            <CustomCheckbox onChange={value => setIsLated(!isLated)} checked={isLated}>
              Veiculo Atrasado
            </CustomCheckbox>
          </div>
          <div className="p-col-4" style={{ paddingTop: 0 }}>
            <CustomDropdown
              disabled={!isLated}
              optionLabel="name"
              options={motivosAtraso}
              value={motivoAtraso}
              label="Motivo de Atraso :*"
              filter={true}
              onChange={value => setMotivoAtraso(value)}
            />
          </div>
          <div className="p-col-4" style={{ paddingTop: 27 }}>
            <Btn onClick={onBtnSalvarClick}>Salvar Informações</Btn>
          </div>
        </div>
      </Fieldset>
    </div>
  )
}

export default connect()(EnvioHorarioSaida)
